import React, { useState } from 'react';
import { BORDER_RADIUS } from '../../../styled';
import AdapexOrGPTSlot from '../../common/AdapexOrGPTSlot';
const AdBoxRowDesktop = ({ appContext, params }) => {
    const { app_id, page_url } = params;
    const { ad_settings } = appContext.publisherClient || {};
    const [rendered, setRendered] = useState(true);
    return rendered ? (<AdapexOrGPTSlot appContext={appContext} params={params} app_id={app_id !== null && app_id !== void 0 ? app_id : ''} id="div-21796380238-fwn-widget-row-desktop" page_url={page_url !== null && page_url !== void 0 ? page_url : ''} path={`/21796380238/${app_id}`} size={(ad_settings === null || ad_settings === void 0 ? void 0 : ad_settings.row_desktop_size) || [[300, 250]]} style={{
            borderRadius: BORDER_RADIUS,
            overflow: 'hidden',
            marginLeft: '10px',
        }} targeting={[
            ['app_id', [app_id !== null && app_id !== void 0 ? app_id : '']],
            ['page_url', [page_url !== null && page_url !== void 0 ? page_url : '']],
        ]} onError={() => setRendered(false)}/>) : null;
};
export default AdBoxRowDesktop;
